// Reset the form fields(checkbox, uploaded file name) on submit
document.addEventListener( 'wpcf7submit', function () {
  $( '.wpcf7-list-item' ).find( 'label' ).removeClass( 'active' );
  $( '.file-name, .named' ).html( '' );
}, false );

$( () => {
  if ( $( 'form.cf7mls' ).length ) {
    // Monitor and remove inline display:none on when form mutates to avoid
    // step hiding when submitted multiple times
    const observer = new MutationObserver( () => {
      let multiSteps = $( '.fieldset-cf7mls' );
      multiSteps.each( ( stepIndex, currentStep ) => {
        let step = $( currentStep );
        if ( step.is( ':hidden' ) ) {
          step.css( 'display', '' );
        }
      } );
    } );
    observer.observe( document.querySelector( 'form.cf7mls' ), {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class', 'style']
    } );
  }
} );
